// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"55c9be7e","453":"2fd2d424"}[chunkId] + ".chunk.js";
};